// extracted by mini-css-extract-plugin
module.exports = {"cost-saving-C":"C_cost-saving-C__6nw90"};